(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.vp-simple-purchase');
    const select = root.querySelector('[data-simple-variant]');
    const add = root.querySelector('[data-simple-add]');
    const label = root.querySelector('[data-simple-label]');
    const subscription = root.querySelector('[data-vp-subscription]');
    const subscriptionToggle = root.querySelector('[data-vp-subscription-toggle]');
    const sellingPlanInput = root.querySelector('[data-vp-selling-plan]');
    const quantityInput = root.querySelector('[data-vp-quantity]');
    const bundleChoices = [...root.querySelectorAll('[data-vp-bundle-choice]')];
    const mixMatch = root.querySelector('[data-vp-mix-match]');
    const mixMatchSelects = [...root.querySelectorAll('[data-vp-mix-match-select]')];
    const subscriptionPrice = root.querySelector('[data-vp-subscription-price]');
    const regularPrice = root.querySelector('[data-vp-regular-price]');
    const offerEyebrow = root.querySelector('[data-vp-offer-eyebrow]');
    const deliveryBenefit = root.querySelector('[data-vp-delivery-benefit]');
    const giftBenefit = root.querySelector('[data-vp-gift-benefit]');
    const singleOptionPrice = root.querySelector('[data-vp-single-option-price]');
    const bundleOptionPrice = root.querySelector('[data-vp-bundle-option-price]');
    const purchaseLabel = root.querySelector('[data-vp-purchase-label]');
    const purchaseNote = root.querySelector('[data-vp-purchase-note]');
    const gift = root.querySelector('[data-vp-gift]');
    const giftLegend = root.querySelector('[data-vp-gift-legend]');
    const giftPrice = root.querySelector('[data-vp-gift-price]');
    const giftStatus = root.querySelector('[data-vp-gift-status]');

    function coverKachingWidget() {
      const widget = document.querySelector('kaching-bundle');
      if (!form || !widget) return false;
      widget.setAttribute('aria-hidden', 'true');
      const cover = () => {
        const styles = getComputedStyle(widget);
        const height = widget.getBoundingClientRect().height + (parseFloat(styles.marginTop) || 0) + (parseFloat(styles.marginBottom) || 0);
        if (height > 20) form.style.marginTop = `-${Math.ceil(height)}px`;
      };
      requestAnimationFrame(cover);
      window.setTimeout(cover, 500);
      if ('ResizeObserver' in window && !widget.dataset.vitalaObserved) {
        widget.dataset.vitalaObserved = 'true';
        new ResizeObserver(cover).observe(widget);
      }
      return true;
    }

    if (!coverKachingWidget()) {
      const observer = new MutationObserver(() => {
        if (coverKachingWidget()) observer.disconnect();
      });
      observer.observe(document.body, {childList:true, subtree:true});
      window.setTimeout(() => observer.disconnect(), 5000);
    }

    function findKachingSubscriptionToggle() {
      const visit = scope => {
        const inputs = scope.querySelectorAll ? [...scope.querySelectorAll('input[type="checkbox"]')] : [];
        const match = inputs.find(input => input !== subscriptionToggle && /subscribe/i.test(input.getAttribute('aria-label') || input.closest('label')?.textContent || ''));
        if (match) return match;
        const elements = scope.querySelectorAll ? [...scope.querySelectorAll('*')] : [];
        for (const element of elements) {
          if (element.shadowRoot) {
            const nested = visit(element.shadowRoot);
            if (nested) return nested;
          }
        }
      };
      return visit(document);
    }

    function confirmKachingBundle() {
      const widget = document.querySelector('kaching-bundle');
      if (!widget) return false;
      const visit = scope => {
        const controls = scope.querySelectorAll ? [...scope.querySelectorAll('button, [role="button"], input[type="radio"]')] : [];
        const match = controls.find(control => {
          const text = `${control.getAttribute?.('aria-label') || ''} ${control.textContent || ''}`.replace(/\s+/g, ' ').toLowerCase();
          return text.includes('buy 2') && (text.includes('get 1') || text.includes('free'));
        });
        if (match) return match;
        const elements = scope.querySelectorAll ? [...scope.querySelectorAll('*')] : [];
        for (const element of elements) {
          if (element.shadowRoot) {
            const nested = visit(element.shadowRoot);
            if (nested) return nested;
          }
        }
      };
      const bundleControl = visit(widget.shadowRoot || widget);
      if (!bundleControl) return false;
      bundleControl.click();
      return true;
    }

    function isBundleSelected() {
      return bundleChoices.find(choice => choice.checked)?.value === 'bundle';
    }

    function updateSubscription(syncKaching = false) {
      if (!subscription || !subscriptionToggle || !sellingPlanInput) return;
      const subscribed = subscriptionToggle.checked;
      const bundled = isBundleSelected();
      const unlocked = subscribed && bundled;
      if (mixMatch) mixMatch.hidden = !bundled;
      sellingPlanInput.disabled = !subscribed;
      sellingPlanInput.value = subscribed ? subscription.dataset.planId : '';
      if (quantityInput) quantityInput.value = '1';
      subscription.classList.toggle('is-once', !subscribed);
      subscription.classList.toggle('is-bundle', bundled);
      subscriptionPrice.textContent = bundled
        ? (subscribed ? subscription.dataset.bundleSubscription : subscription.dataset.bundleOnce)
        : (subscribed ? subscription.dataset.singleSubscription : subscription.dataset.singleOnce);
      if (regularPrice) {
        regularPrice.textContent = bundled ? subscription.dataset.bundleRegular : subscription.dataset.singleRegular;
        regularPrice.hidden = !subscribed && !bundled;
      }
      if (offerEyebrow) offerEyebrow.textContent = bundled ? 'BUY 2, GET 1 FREE' : '1 PACK';
      purchaseLabel.textContent = subscribed ? 'Monthly subscription' : 'One-time purchase';
      purchaseNote.textContent = subscribed ? `${bundled ? 3 : 1} ${bundled ? 'packs' : 'pack'} delivered every 30 days` : `${bundled ? 3 : 1} ${bundled ? 'packs' : 'pack'} delivered once`;
      if (deliveryBenefit) deliveryBenefit.textContent = `${bundled ? 90 : 30} patches delivered ${subscribed ? 'every 30 days' : 'once'} with free shipping`;
      if (giftBenefit) giftBenefit.textContent = unlocked ? 'Free Vitala Everyday Wellness Guide with your first order' : bundled ? 'Subscribe to unlock your free Vitala guide' : 'Choose the 2 + 1 bundle to unlock your free Vitala guide';
      gift?.classList.toggle('is-unlocked', unlocked);
      gift?.classList.toggle('is-locked', !unlocked);
      if (giftLegend) giftLegend.textContent = unlocked ? 'GIFT UNLOCKED' : bundled ? 'SUBSCRIBE TO UNLOCK' : 'CHOOSE BUNDLE TO UNLOCK';
      if (giftPrice) giftPrice.textContent = unlocked ? 'FREE' : 'LOCKED';
      if (giftStatus) giftStatus.textContent = unlocked ? '✓' : '🔒';
      if (singleOptionPrice) singleOptionPrice.textContent = subscribed ? subscription.dataset.singleSubscription : subscription.dataset.singleOnce;
      if (bundleOptionPrice) bundleOptionPrice.textContent = subscribed ? subscription.dataset.bundleSubscription : subscription.dataset.bundleOnce;
      if (label && !add.disabled) label.textContent = 'Add to cart';
      sellingPlanInput.dispatchEvent(new Event('change', {bubbles:true}));
      if (syncKaching && bundled) {
        const kachingToggle = findKachingSubscriptionToggle();
        if (kachingToggle) {
          if (kachingToggle.checked !== subscribed) kachingToggle.click();
        }
      }
    }

    function update() {
      if (!select) return;
      const option = select.selectedOptions[0];
      const available = option?.dataset.available === 'true';
      const requiresPlan = option?.dataset.requiresPlan === 'true';
      add.disabled = !available || requiresPlan;
      label.textContent = !available ? 'Sold out' : requiresPlan ? 'Subscription required' : add.dataset.label;
    }
    subscriptionToggle?.addEventListener('change', () => updateSubscription(true));
    bundleChoices.forEach(choice => choice.addEventListener('change', () => {
      if (choice.checked) bundleChoices.forEach(other => { if (other !== choice) other.checked = false; });
      if (choice.checked && choice.value === 'bundle') confirmKachingBundle();
      updateSubscription(true);
    }));
    select?.addEventListener('change', update);
    form?.addEventListener('submit', async event => {
      if (add.disabled) return event.preventDefault();
      event.preventDefault();
      event.stopImmediatePropagation();
      add.setAttribute('aria-busy', 'true');
      const variantInput = select || form.querySelector('[name="id"]');
      const variantId = Number(variantInput.value);
      const sellingPlanId = Number(subscription.dataset.planId);
      const subscribed = subscriptionToggle.checked;
      let items;
      if (!isBundleSelected()) {
        const item = { id: variantId, quantity: 1 };
        if (subscribed) item.selling_plan = sellingPlanId;
        items = [item];
      } else {
        const bundleId = `vitala-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const shared = {deal:'Qzas', bar:'9bsN', v:'7d5d70d0-587f-442b-a691-b3812f433b2f', id:bundleId};
        const selections = mixMatchSelects.length === 3
          ? mixMatchSelects.map(field => ({id:Number(field.value), productId:Number(field.selectedOptions[0]?.dataset.productId)}))
          : [{id:variantId, productId:Number(subscription.dataset.productId)}, {id:variantId, productId:Number(subscription.dataset.productId)}, {id:variantId, productId:Number(subscription.dataset.productId)}];
        const paid = selections.slice(0, 2).map(selection => ({
          id: selection.id,
          quantity: 1,
          properties: {
            __kaching_bundles: JSON.stringify({...shared, pp:selection.productId, main:true}),
            _vitala_gift: subscribed ? 'Vitala Everyday Wellness Guide' : ''
          }
        }));
        const free = {
          id: selections[2].id,
          quantity: 1,
          properties: {__kaching_bundles: JSON.stringify({...shared, main:true, bxgy:true})}
        };
        if (subscribed) {
          paid.forEach(item => { item.selling_plan = sellingPlanId; });
          free.selling_plan = sellingPlanId;
        }
        items = [free, ...paid];
        if (subscribed) {
          items.unshift({
            id: 54911106941267,
            quantity: 1,
            properties: {__kaching_bundles: JSON.stringify({...shared, gift:'_abg'})}
          });
        }
      }
      const addItems = async cartItems => {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js?kaching_bundles=true`, {
          method: 'POST',
          headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body: JSON.stringify({items:cartItems})
        });
        if (!response.ok) {
          const payload = await response.json();
          const error = new Error(payload.description || 'Could not add this item.');
          error.description = payload.description || '';
          throw error;
        }
        return response.json();
      };
      try {
        try {
          await addItems(items);
        } catch (error) {
          const giftUnavailable = isBundleSelected() && subscribed && /cannot find variant/i.test(error.description || error.message);
          if (!giftUnavailable) throw error;
          await addItems(items.filter(item => Number(item.id) !== 54911106941267));
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.setTimeout(() => document.querySelector('cart-drawer')?.show(), 350);
      } catch (error) {
        if (label) label.textContent = error.message || 'Could not add this bundle.';
        form.dispatchEvent(new CustomEvent('cart:error', {bubbles:true, detail:{error:error.message}}));
      } finally {
        add.removeAttribute('aria-busy');
      }
    }, true);
    const gallery = root.querySelector('[data-gallery]');
    root.querySelectorAll('[data-slide]').forEach(button => button.addEventListener('click', () => {
      gallery.scrollTo({left:Number(button.dataset.slide) * gallery.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    gallery.addEventListener('scroll', () => { const index = Math.round(gallery.scrollLeft / gallery.clientWidth); root.querySelectorAll('[data-slide]').forEach(b => b.setAttribute('aria-pressed',String(Number(b.dataset.slide) === index))); }, {passive:true});
    root.querySelectorAll('[data-stock-counter]').forEach(card => {
      const target = Math.min(100, Math.max(0, Number(card.dataset.stockTarget) || 0));
      const number = card.querySelector('[data-stock-number]');
      const fill = card.querySelector('[data-stock-fill]');
      const track = card.querySelector('[role="progressbar"]');
      const paint = value => {
        number.textContent = String(Math.round(value));
        fill.style.width = value + '%';
        track.setAttribute('aria-valuenow', String(Math.round(value)));
      };
      if (card.dataset.stockAnimate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        paint(target);
        return;
      }
      paint(0);
      const start = () => {
        const began = performance.now();
        const tick = now => {
          if (!card.isConnected) return;
          const progress = Math.min(1, (now - began) / 1400);
          paint(target * (1 - Math.pow(1 - progress, 3)));
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            observer.disconnect();
            start();
          }
        }, {threshold:0.25});
        observer.observe(card);
      } else start();
    });
    update();
    updateSubscription();
    const prepareKaching = () => {
      confirmKachingBundle();
      updateSubscription(true);
    };
    window.setTimeout(prepareKaching, 900);
    window.setTimeout(prepareKaching, 1600);
  }
  document.querySelectorAll('[data-vitala-pdp]').forEach(init);
  if (!window.vitalaPdpEditorBound) {
    window.vitalaPdpEditorBound = true;
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-vitala-pdp]').forEach(init));
  }
})();
